import { useEffect } from "react";

import { UserManager } from "oidc-client-ts";

import { appConfig } from "@/common/config";
import Loader from "@/components/Layouts/Loader";

const Logout = () => {
    const userManager = new UserManager(appConfig.settings);

    const handleLogout = async () => {
        await userManager.clearStaleState();
        await userManager.signoutRedirect();
    }

    useEffect(() => {
        handleLogout();
    }, [])

    return (
        <Loader />
    )
}

export default Logout;
